import { useEffect } from "react";
import { usePublicSettings } from "@/hooks/useCMSSettings";

export default function SEOManager() {
  const { seo } = usePublicSettings();

  useEffect(() => {
    if (!seo) return;

    // Helper function to update meta tags
    const updateMetaTag = (attributeName: string, attributeValue: string, content: string) => {
      let element = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attributeName, attributeValue);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Update Title
    if (seo.title) {
      document.title = seo.title;
      updateMetaTag("property", "og:title", seo.title);
      updateMetaTag("property", "twitter:title", seo.title);
    }

    // Update Meta Description
    if (seo.description) {
      updateMetaTag("name", "description", seo.description);
      updateMetaTag("property", "og:description", seo.description);
      updateMetaTag("property", "twitter:description", seo.description);
    }

    // Update Meta Keywords
    if (seo.keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement("meta");
        metaKeywords.setAttribute("name", "keywords");
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute("content", seo.keywords);
    }
  }, [seo]);

  return null;
}
